import React, { useContext, useState } from 'react';
import { Alert, Button, Form, Input, message } from 'antd';
import axios from 'axios';
import { processReq } from '../helpers/processRequest';
import { GET } from '../utils/requestActionConstants';
import { API_ROUTE, SERVER_ROUTE } from '../utils/commonConstants';
import { AuthContext } from '../context/AuthContextProvider';

const Login = () => {
    const { login, isLoggedIn } = useContext(AuthContext);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const onFinish = async ({ email, password }) => {
        setIsLoading(true);

        try {
            let result = await login(email, password);

            if (result) {
                setIsError(true);
                setErrorMessage(result);
                // message.error(result);
            }
        } catch (error) {
            setIsError(true);
            setErrorMessage(error.toString());
            message.error(error.toString());
        } finally {
            setIsLoading(false);
        }
        
    };

    const onFinishFailed = (errorInfo) => {
        console.log(errorInfo)
        setIsLoading(false);
    };

    const onClose = (e) => {
        setIsError(false);
        setIsLoading(false);
    };

    return (
        <div className='flex md:flex-row flex-col justify-center items-center h-screen md:pr-10'>
            <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-2xl '>Weda Arana Admin Portal</div>
            <div className='px-4'>
                <Form
                    name="login"
                    layout="vertical"
                    style={{ width: '300px' }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <div className='text-3xl text-center py-10'>Sign In</div>

                    <Form.Item
                        label="User Email"
                        name="email"
                        initialValue={''}
                        rules={[
                            {
                                required: true,
                                message: 'Please input your email!',
                            },
                        ]}
                    >
                        <Input placeholder='email' />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        initialValue={''}
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            },
                        ]}
                    >
                        <Input.Password placeholder='password' />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={isLoading} block>
                            Login
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        {isError ?
                            <Alert
                                message={errorMessage}
                                type="warning"
                                closable
                                afterClose={onClose}
                            />
                            : ''}
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}

export default Login;